<template>
  <div class="modal fade" id="floorFormModal" tabindex="-1" aria-labelledby="floorFormModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="floorFormModalLabel">Planta</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <v-form
          ref="modalForm"
          @submit="store"
          :validation-schema="formSchema"
          :initial-values="formValues"
          v-slot="{ errors }"
        >
          <div class="modal-body">
            <div class="mb-3">
              <label for="nameInput" class="form-label">Nombre</label>

              <v-field
                name="nombre"
                as="input"
                type="text"
                id="nameInput"
                class="form-control"
              />

              <span class="fs-6 text-danger">{{ errors.nombre }}</span>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cancelar
            </button>

            <button class="btn btn-primary">
              Guardar
            </button>
          </div>
        </v-form>
      </div>
    </div>
  </div>

  <toast :config="alert"></toast>
</template>

<script>
// @ is an alias to /src
import APIFloor from '@/api/floor';
import { Form as VForm, Field as VField } from 'vee-validate';
import { setLocale } from 'yup';
import * as yup from 'yup';
import { reactive, watchEffect, getCurrentInstance } from 'vue';
import $ from 'jquery'

setLocale({
  mixed: {
    required: 'El campo es requerido',
  },
});

export default {
  props: {
    form: Object,
  },

  components: {
    VField,
    VForm,
  },

  emits: ['store'],

  setup(props, { emit }) {
    const internalInstance = getCurrentInstance()

    const alert = reactive({
      message: "",
      title: "",
    })

    const formSchema = {
      nombre: yup.string().required(),
    }

    const formValues = reactive({
      id: '',
      nombre: '',
    })

    function store(values) {
      props.form.ID ? update(props.form.ID, values) : save(values);
    }

    function save(values) {
      values.emp_id = parseInt(localStorage.empresa_id);

      APIFloor.post(values)
        .then(() => {
          $('#floorFormModal').modal('hide');
          emit('store');
        })
        .catch((error) => {
          alert.title = "Error al crear";
          alert.message = error.response ? error.response.data.msg : 'Error en la petición';
          $('#toast').toast('show');
        });
    }

    function update(id, values) {
      values.emp_id = parseInt(localStorage.empresa_id);

      APIFloor.patch(id, values)
        .then(() => {
          $('#floorFormModal').modal('hide');
          emit('store');
        })
        .catch((error) => {
          alert.title = "Error al actualizar";
          alert.message = error.response ? error.response.data.msg : 'Error en la petición';
          $('#toast').toast('show');
        });
    }

    watchEffect(() => {
      if (internalInstance.refs.modalForm) {
        internalInstance.refs.modalForm.resetForm()
      }

      if (props.form.ID != undefined) {
        formValues.id = props.form.ID;
        formValues.nombre = props.form.Nombre;
      } else {
        formValues.id = '';
        formValues.nombre = '';
      }
    })

    return {
      alert,
      formSchema,
      formValues,
      store,
      save,
      update,
      internalInstance,
    }
  }
}
</script>
